export const transientProps = <T>(...propsToNotForward: T[]) => ({
  shouldForwardProp: (prop: PropertyKey) => !propsToNotForward.flatMap(
    (val: T) => val,
  ).includes(prop as unknown as T),
});
